import { AxiosResponse } from 'axios'
import {
  DatabaseConfigurationViewModel,
  EmptyApiResult,
  NewCustomerAgencyShardMappingViewModel,
  BlueGreenConfigurationViewModel,
} from '../api'
import { useApiClient } from './useApiClient'

type BasicResponse = {
  success: boolean
}

export const useSystemApi = () => {
  const apiClient = useApiClient()

  const getDatabaseConfiguration = () => {
    return apiClient.request<
      void,
      AxiosResponse<DatabaseConfigurationViewModel>
    >({
      url: 'api/system/database',
      method: 'get',
      withCredentials: true,
    })
  }

  const getShardMappingRulesForNewCustomers = () => {
    return apiClient.request<
      void,
      AxiosResponse<NewCustomerAgencyShardMappingViewModel[]>
    >({
      url: 'api/system/database/shard/rules',
      method: 'get',
      withCredentials: true,
    })
  }

  const getDefaultShardForNewCustomers = () => {
    return apiClient.request<void, AxiosResponse<number>>({
      url: 'api/system/database/shard/default',
      method: 'get',
      withCredentials: true,
    })
  }

  const setDefaultShardForNewCustomers = (shard: number) => {
    return apiClient.request<void, AxiosResponse<EmptyApiResult>>({
      url: `api/system/database/shard/default?newShard=${shard}`,
      method: 'post',
      withCredentials: true,
    })
  }

  const getBlueGreenConfiguration = () => {
    return apiClient.request<
      void,
      AxiosResponse<BlueGreenConfigurationViewModel>
    >({
      url: 'api/system/blueGreen',
      method: 'get',
      withCredentials: true,
    })
  }

  const notifyBlueGreenStarted = () => {
    return apiClient.request<void, AxiosResponse<void>>({
      url: 'api/system/blueGreen/start',
      method: 'post',
      withCredentials: true,
    })
  }

  const notifyBlueGreenEnded = () => {
    return apiClient.request<void, AxiosResponse<void>>({
      url: 'api/system/blueGreen/stop',
      method: 'post',
      withCredentials: true,
    })
  }

  const requestImportLockDrain = () => {
    return apiClient.request<void, AxiosResponse<void>>({
      url: 'api/system/blueGreen/drain',
      method: 'post',
      withCredentials: true,
    })
  }

  const stopImportLockDrain = () => {
    return apiClient.request<void, AxiosResponse<void>>({
      url: 'api/system/blueGreen/drain',
      method: 'delete',
      withCredentials: true,
    })
  }

  return {
    getDatabaseConfiguration,
    getShardMappingRulesForNewCustomers,
    getDefaultShardForNewCustomers,
    setDefaultShardForNewCustomers,
    getBlueGreenConfiguration,
    notifyBlueGreenStarted,
    notifyBlueGreenEnded,
    requestImportLockDrain,
    stopImportLockDrain,
  }
}
